import React from "react";
import styles from 'styles/HamburgerMenu.module.css';
import LogoWhiteName from 'assets/images/header/logo_touka_white_name.png';
import YTBtn from 'assets/images/header/btn_yt.svg';
import XBtn from 'assets/images/header/xlogo.svg';
import { Link } from 'react-router-dom';

const HamburgerMenu: React.FC<{
    isOpen: boolean;
    closeMenu: () => void;
  }> = ({ isOpen, closeMenu }) => {
  return (
    <div className={`${styles["menu"]} ${isOpen ? styles["open"] : ""}`}>
      <button className={styles["close-button"]} onClick={closeMenu}>
        &times;
      </button>

      <div className={styles["hamburger-container"]}>
        <div className={styles["hamburger-left"]}>
          <img src={LogoWhiteName} alt="ロゴ" draggable="false" />
        </div>
        <div className={styles["hamburger-right"]}>
          <ul>
            <Link to="/" onClick={closeMenu}><li>TOP</li></Link>
            <Link to="/#news" onClick={closeMenu}><li>THE LATEST</li></Link>
            <Link to="/#about" onClick={closeMenu}><li>ABOUT</li></Link>
            <Link to="/#ranking" onClick={closeMenu}><li>RANKING</li></Link>
            <Link to="/#schedule" onClick={closeMenu}><li>SCHEDULE</li></Link>
            <Link to="/#sns" onClick={closeMenu}><li>SNS</li></Link>
            {/* <Link to="/rulebook" onClick={closeMenu}><li>RULEBOOK</li></Link> */}
            <Link to="/guideline" onClick={closeMenu}><li>GUIDELINE</li></Link>
            <Link to="/staff-wanted" onClick={closeMenu}><li>STAFF WANTED</li></Link>
            {/* <Link to="/credit" onClick={closeMenu}><li>CREDIT</li></Link> */}
          </ul>
          <div className={styles["sns"]}>
            <a
              href="https://x.com/splatoon_zone"
              target="_blank"
              rel="noopener noreferrer"
              className={styles["circle"]}
            >
              <img src={XBtn} alt="X" />
            </a>
            <a
              href="https://www.youtube.com/@splatzonejp"
              target="_blank"
              rel="noopener noreferrer"
              className={styles["circle"]}
            >
              <img src={YTBtn} alt="YouTube" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HamburgerMenu;
